<template>
  <div class="giftBagList">
    <div class="giftItem" v-for="(item, i) in filterData" :key="'item' + i">
      <img class="mainImg" :src="item.skuImageUrl" alt />
      <div class="proInfo">
        <div class="title">{{ item.skuName|| item.couponName}}</div>
        <div class="title" v-if="type=='coupon'" style="display:flex">
          <div>有效时间：</div>
          <div style="flex:1">{{item.useStartTime}} ~ {{item.useEndTime}}</div>
        </div>
        <div class="bottom">
          <span>×{{ item.num }}</span>
          <span v-if="type=='package'">总价值:￥{{ (item.num * item.originalPrice).toFixed(2) }}</span>
        </div>
      </div>
    </div>
    <div class="no-data" v-if="!filterData?.length">暂无更多卡券</div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { formatFullDate } from '@/util/filter'
import fetch from '@/plugin/axios'

export default {
  name: '',
  props: {
    type: {
      type: String,
      default: ''
    },
    cuoponList:{
      type: Array,
      default: []
    },
  },
  data() {
    return {
      // cuoponList: []
    }
  },
  computed: {
    ...mapGetters({
      detail: 'mall/product/productDetail'
    }),
    list() {
      return this.detail.skuPackageList[0]?.skuList
    },
    filterData() {
      let list = this.type == 'coupon' ? this.cuoponList : this.list
      return list.length && list
    }
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
.giftBagList {
  padding: 14px 14px 70px;

  .giftItem {
    background: #ffffff;
    box-shadow: 0px 6px 16px -6px rgba(151, 145, 145, 0.06);
    border-radius: 12px;
    padding: 10px 8px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    height: 94px;
    .mainImg {
      width: 76px;
      height: 76px;
      margin-right: 10px;
      border-radius: 6px;
    }
    .proInfo {
      height: 100%;
      width: 100%;
      font-size: 14px !important;
      position: relative;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .title {
        font-weight: 500;
        color: #333333;
        line-height: 16px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        // position: absolute;
        // bottom: 0;
        width: 100%;
        span {
          &:nth-child(1) {
            color: #666666;
          }
          &:nth-child(2) {
            color: #e7141a;
          }
        }
      }
    }
  }
  .no-data{
    height: 35vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
